module.exports = __webpack_public_path__ + "static/media/referralconfiguration.64871a35.svg";